// extracted by mini-css-extract-plugin
export default {"reactswitchcheckbox":"styles_reactswitchcheckbox__66Fjn","reactswitchlabel":"styles_reactswitchlabel__gqR7y","reactswitchbutton":"styles_reactswitchbutton__Q77zU"};